// ===========================================
// Security Audit Hooks
// ===========================================
// React Query hooks for security audit log operations

import { useQuery } from '@tanstack/react-query';
import * as securityAuditApi from '../api/securityAudit.api';
import { SecurityAuditFilters } from '../api/securityAudit.api';

// ===========================================
// QUERY KEYS
// ===========================================

export const securityAuditKeys = {
  all: ['security-audit'] as const,
  logs: (filters: SecurityAuditFilters, limit: number, offset: number) =>
    [...securityAuditKeys.all, 'logs', filters, limit, offset] as const,
  actions: () => [...securityAuditKeys.all, 'actions'] as const,
};

// ===========================================
// HOOKS
// ===========================================

/**
 * Get security audit logs with optional filtering
 */
export function useSecurityAuditLogs(
  filters: SecurityAuditFilters = {},
  limit = 100,
  offset = 0
) {
  return useQuery({
    queryKey: securityAuditKeys.logs(filters, limit, offset),
    queryFn: () => securityAuditApi.getSecurityAuditLogs(filters, limit, offset),
  });
}

/**
 * Get available audit action types
 */
export function useAuditActions() {
  return useQuery({
    queryKey: securityAuditKeys.actions(),
    queryFn: securityAuditApi.getAuditActions,
  });
}
